import React, { Component } from "react";
import { Text } from "@chakra-ui/react";
import { withTranslation } from "react-i18next";
import TldrChakraSlider from "../../common/TldrChakraSlider";

class TLDRDownloadJPEGFileQuality extends Component {
  render() {
    const { imageQuality, t } = this.props;
    return (
      <>
        <Text fontSize="xs" casing="uppercase" mb={2}>
          {t("jpg_quality")}
        </Text>
        <TldrChakraSlider
          domain={[0, 100]}
          onChange={this.onChange}
          values={imageQuality}
          showDecimals={false}
          variant="solid"
        ></TldrChakraSlider>
      </>
    );
  }

  onChange = (value) => {
    this.props.onImageQualityChange(value);
  };
}

TLDRDownloadJPEGFileQuality.propTypes = {};

export default withTranslation(["navbar"])(TLDRDownloadJPEGFileQuality);
